module.exports = __webpack_public_path__ + "static/coffee-group-coaching-0a256da1bbae44fca0ad02e8c104c097.jpg";